<template>
    <div v-if="statistics">
        <div v-if="statistics.name">
            <h4>{{statistics.market}} {{ statistics.name }}</h4>

            <h5>Summary</h5>
            <div v-if="statistics.summary">
                <table class="table">
                    <th v-for="(value, propertyName) in statistics.summary">
                        {{ propertyName }}
                    </th>

                    <tr>
                        <td v-for="(value, propertyName) in statistics.summary">
                            {{ value }}
                        </td>
                    </tr>
                </table>
            </div>

            <h5>Rushing Players</h5>
            <div v-if="statistics.rushing">
                <table class="table">
                    <th v-for="(value, propertyName) in statistics.rushing.players[0]">
                        {{ propertyName }}
                    </th>

                    <tr v-for="player in statistics.rushing.players">
                        <td v-for="(value, propertyName) in player">
                            {{ value }}
                        </td>
                    </tr>
                </table>
            </div>

            <h5>Receiving Players</h5>
            <div v-if="statistics.receiving">
                <table class="table">
                    <th v-for="(value, propertyName) in statistics.receiving.players[0]">
                        {{ propertyName }}
                    </th>

                    <tr v-for="player in statistics.receiving.players">
                        <td v-for="(value, propertyName) in player">
                            {{ value }}
                        </td>
                    </tr>
                </table>
            </div>

            <h5>Penalties Players</h5>
            <div v-if="statistics.penalties">
                <table class="table">
                    <th v-for="(value, propertyName) in statistics.penalties.players[0]">
                        {{ propertyName }}
                    </th>

                    <tr v-for="player in statistics.penalties.players">
                        <td v-for="(value, propertyName) in player">
                            {{ value }}
                        </td>
                    </tr>
                </table>
            </div>

            <h5>Passing Players</h5>
            <div v-if="statistics.passing">
                <table class="table">
                    <th v-for="(value, propertyName) in statistics.passing.players[0]">
                        {{ propertyName }}
                    </th>

                    <tr v-for="player in statistics.passing.players">
                        <td v-for="(value, propertyName) in player">
                            {{ value }}
                        </td>
                    </tr>
                </table>
            </div>

            <h5>Kickoffs Players</h5>
            <div v-if="statistics.kickoffs">
                <table class="table">
                    <th v-for="(value, propertyName) in statistics.kickoffs.players[0]">
                        {{ propertyName }}
                    </th>

                    <tr v-for="player in statistics.kickoffs.players">
                        <td v-for="(value, propertyName) in player">
                            {{ value }}
                        </td>
                    </tr>
                </table>
            </div>

            <h5>Fumbles Players</h5>
            <div v-if="statistics.fumbles">
                <table class="table">
                    <th v-for="(value, propertyName) in statistics.fumbles.players[0]">
                        {{ propertyName }}
                    </th>

                    <tr v-for="player in statistics.fumbles.players">
                        <td v-for="(value, propertyName) in player">
                            {{ value }}
                        </td>
                    </tr>
                </table>
            </div>

            <h5>Defense Players</h5>
            <div v-if="statistics.defense">
                <table class="table">
                    <th v-for="(value, propertyName) in statistics.defense.players[0]">
                        {{ propertyName }}
                    </th>

                    <tr v-for="player in statistics.defense.players">
                        <td v-for="(value, propertyName) in player">
                            {{ value }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'NFLGameStatistics',
    props: {
        statistics: '',
    },
    data: function() {
        return {            
        }
    }, 
}
</script>

